import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useList = (path, params) =>
  useQuery({ queryKey: [path, params], queryFn: () => api.get(path, { params }).then((r) => r.data) });

export const useRefs = () => {
  const clients = useList("/admin/clients").data || [];
  const logements = useList("/admin/logements").data || [];
  const formules = useList("/admin/formules").data || [];
  const chantiers = useList("/admin/chantiers").data || [];
  const employes = useList("/admin/employes").data || [];
  const byId = (arr) => Object.fromEntries(arr.map((x) => [x.id, x]));
  return { clients, logements, formules, chantiers, employes, employesById: byId(employes), clientsById: byId(clients), logementsById: byId(logements), formulesById: byId(formules) };
};

export const useInvalidate = () => {
  const qc = useQueryClient();
  return () => qc.invalidateQueries();
};
